import { useState } from 'react';

export default function Testimonials() {
  const testimonials = [
    {
      quote: 'Prakash Electricals [OPK] delivered exceptional work on our commercial project. Professional, timely, and safety-focused. Their attention to detail and commitment to quality made our collaboration seamless.',
      name: 'Rajesh Sharma',
      position: 'Project Manager, Magna Yuma Private Limited',
      image: 'https://public.readdy.ai/ai/img_res/fd7632f4d88511459ab9b32e73f38c52.jpg'
    },
    {
      quote: 'Outstanding electrical contracting services! The team handled our complex installation requirements with expertise and precision. Highly recommend Prakash Electricals for any commercial electrical work.',
      name: 'Priya Mehta',
      position: 'Operations Head, Bel Cibo',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20indian%20businesswoman%20in%20formal%20business%20attire%20confident%20professional%20headshot%20photography%20with%20clean%20neutral%20background%20emphasizing%20leadership%20and%20expertise%20warm%20professional%20lighting%20suitable%20for%20corporate%20testimonial&width=320&height=440&seq=testimonial-002&orientation=portrait'
    },
    {
      quote: 'We have worked with Prakash Electricals on multiple residential projects. Their reliability, transparent pricing, and quality workmanship make them our preferred electrical contractor.',
      name: 'Amit Patel',
      position: 'Builder & Contractor',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20indian%20construction%20professional%20in%20business%20casual%20attire%20confident%20professional%20headshot%20photography%20with%20clean%20neutral%20background%20emphasizing%20experience%20and%20reliability%20warm%20lighting%20suitable%20for%20business%20testimonial&width=320&height=440&seq=testimonial-003&orientation=portrait'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-12 text-center">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
          <p className="text-gray-600">Trusted by businesses and homeowners across India</p>
        </div>

        <div className="relative">
          <div className="bg-black rounded-[32px] overflow-hidden">
            <div className="grid md:grid-cols-3 gap-0">
              <div className="relative md:col-span-1 h-full min-h-[440px]">
                <img
                  src={testimonials[currentIndex].image}
                  alt={testimonials[currentIndex].name}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="md:col-span-2 p-12 md:p-16 flex flex-col justify-center">
                <div className="text-amber-100 text-6xl mb-6">"</div>

                <p className="text-xl text-white leading-relaxed mb-8">
                  {testimonials[currentIndex].quote}
                </p>

                <div className="mb-8">
                  <div className="text-white font-medium mb-1">
                    {testimonials[currentIndex].name}
                  </div>
                  <div className="text-gray-400 text-sm">
                    {testimonials[currentIndex].position}
                  </div>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={prevTestimonial}
                    className="px-6 py-3 bg-rose-400 text-gray-900 rounded-full font-medium hover:bg-rose-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    ← Previous
                  </button>
                  <button
                    onClick={nextTestimonial}
                    className="px-6 py-3 bg-rose-400 text-gray-900 rounded-full font-medium hover:bg-rose-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Next →
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-sky-500 w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center p-8 bg-slate-50 rounded-2xl">
            <div className="text-4xl font-bold text-sky-500 mb-2">100%</div>
            <div className="text-gray-600">Client Satisfaction</div>
          </div>
          <div className="text-center p-8 bg-slate-50 rounded-2xl">
            <div className="text-4xl font-bold text-sky-500 mb-2">10+</div>
            <div className="text-gray-600">Projects Delivered</div>
          </div>
          <div className="text-center p-8 bg-slate-50 rounded-2xl">
            <div className="text-4xl font-bold text-sky-500 mb-2">3+</div>
            <div className="text-gray-600">Years of Excellence</div>
          </div>
        </div>
      </div>
    </section>
  );
}
